import React from 'react';
import styles from './Projects.module.css';

const ProjectsLoadingState = () => {
  return (
    <div className={styles.container}>
      <div className={styles.loadingState}>
        <div className={`${styles.skeleton} ${styles.skeletonHeader}`} />
        <div className={styles.skeletonCards}>
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonCard}`} />
        </div>
        <div className={styles.skeletonGrid}>
          <div className={`${styles.skeleton} ${styles.skeletonProjectCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonProjectCard}`} />
          <div className={`${styles.skeleton} ${styles.skeletonProjectCard}`} />
        </div>
      </div>
    </div>
  );
};

export default ProjectsLoadingState;